import axios from 'axios';

const baseURL = process.env.CONTENT_ENGINE_URL;
const publishBaseUrl = `${baseURL}/app/publishing`;

const publish = {
    // GET /app/publishing/{publishId}/diff
    async getDiff(publishId) {
        return axios.get(
            `${publishBaseUrl}/${publishId}/diff`
        );
    },

    // POST /app/publishing/{publishId}/accept
    async merge(publishId) {
        return axios.post(
            `${publishBaseUrl}/${publishId}/accept`
        );
    }
};

export default publish;



// WEBPACK FOOTER //
// ./src/api/publish.js